module.exports = __webpack_public_path__ + "static/media/3_Jessika_L@3x.9a707dc4.jpg";